module.exports = __webpack_public_path__ + "img/database.16336df2.png";